import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69f6114cf6558f0014c8ec38/startcanon/src/app/page.tsx");
